/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {BaseValidator} from "./BaseValidator";
import React, {Fragment} from "react";
import {service as SurveyService} from "../../../Services/SurveyService";
import {ObjectUtils} from "../../../Utils";

export class SurveyValidator extends BaseValidator {
    constructor () {
        super();

        this.duplicated = null;
        this.lastSearch = {};
    }

    name(model) {
        return this.message(model);
    }

    async logic(model, data) {
        const { surveyId, organizationId, surveyTypeId, conservationActionTypeId, SurveyPrograms } = data;

        const currentSearch = {surveyId, surveyTypeId, conservationActionTypeId, organizationId, SurveyPrograms};

        // don't check for duplicates unless one of the relevant fields changed
        // unfortunately there is no way to prevent this from happening at least
        // once because when the validator is initialized we don't have a reference
        // to the "data" structure. (see GenericModelViewerBase.validate() which
        // calls this.props.Model.recordValidators)
        if(!ObjectUtils.Compare(currentSearch, this.lastSearch)) {

            const { result, error } = await SurveyService.GetSurveys(surveyTypeId, conservationActionTypeId, organizationId);
            if (error) {
                console.error(error);
                return true;
            }

            this.duplicated = result.find(x => (
                surveyId !== x.surveyId &&
                (
                    (x?.SurveyPrograms?.length === 0 && data?.SurveyPrograms?.length === 0) ||
                    (data?.SurveyPrograms.some(dataProgram => (
                        x?.SurveyPrograms.find(surveyProgram => surveyProgram.programId === dataProgram.programId)
                    )))
                )
            ));

            this.lastSearch = currentSearch;
        }

        return this.duplicated == null;
    }

    message(model, data) {
        if (!!data?.SurveyPrograms?.length) {
            return <Fragment>
                A specific Program already exists in this Survey Type, Conservation Action Type, and Organization combination.
            </Fragment>;
        }

        return <Fragment>
            This Survey Type, Conservation Action Type, and Organization combination already exists.
        </Fragment>;
    }
};
